import { useState, type FormEvent } from 'react';

import heroWide from '@/assets/login-hero-wide.webp';
import hero from '@/assets/login-hero.webp';
import { Button, Field } from '@/shared/ui/index.js';

import { useLogin } from '../application/use-login.js';

import styles from './login-page.module.css';

export function LoginPage() {
  const { submit, fieldErrors, isSubmitting, error } = useLogin();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  function onSubmit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    submit({ username, password });
  }

  return (
    <main className={styles.screen}>
      <section aria-hidden="true" className={styles.visual}>
        <img alt="" className={styles.visualImg} src={hero} />
        <div className={styles.visualVeil} />
        <div className={styles.visualContent}>
          <div className={styles.visualBrand}>
            <span className={styles.visualMark}>IC</span>
            <span className={styles.visualBrandText}>
              <span className={styles.visualBrandName}>Inventario Cocina</span>
              <span className={styles.visualBrandSub}>Pecepe</span>
            </span>
          </div>

          <div className={styles.visualCopy}>
            <h2 className={styles.visualHeadline}>Tu cocina, bajo control</h2>
            <p className={styles.visualText}>
              Insumos, kardex y menús del día en un solo lugar, con el stock siempre al día.
            </p>
          </div>

          <div className={styles.visualStats}>
            <span className={styles.stat}>
              <span className={styles.statValue}>Kardex</span>
              <span className={styles.statLabel}>Trazabilidad total</span>
            </span>
            <span className={styles.stat}>
              <span className={styles.statValue}>Alertas</span>
              <span className={styles.statLabel}>Stock mínimo</span>
            </span>
            <span className={styles.stat}>
              <span className={styles.statValue}>Reportes</span>
              <span className={styles.statLabel}>Consumo y costos</span>
            </span>
          </div>
        </div>
      </section>

      <div className={styles.formSide}>
        <div className={styles.panel}>
          <div aria-hidden="true" className={styles.mobileBanner}>
            <img alt="" src={heroWide} />
            <div className={styles.mobileBannerVeil}>
              <p className={styles.mobileBannerText}>Tu cocina, bajo control</p>
            </div>
          </div>

          <header className={styles.brand}>
            <span aria-hidden="true" className={styles.mark}>
              IC
            </span>
            <h1 className={styles.title}>Inventario Cocina</h1>
            <p className={styles.subtitle}>Ingresa con tu usuario del sistema.</p>
          </header>

          {error === undefined ? null : (
            <p className={styles.alert} role="alert">
              {error.message}
            </p>
          )}

          <form className={styles.form} noValidate onSubmit={onSubmit}>
            <Field
              autoComplete="username"
              error={fieldErrors.username}
              label="Usuario"
              name="username"
              onChange={(event) => {
                setUsername(event.target.value);
              }}
              placeholder="Ej. gerencia"
              value={username}
            />
            <Field
              autoComplete="current-password"
              error={fieldErrors.password}
              label="Contraseña"
              name="password"
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              type="password"
              value={password}
            />
            <Button block busyLabel="Ingresando..." isBusy={isSubmitting} type="submit">
              Ingresar
            </Button>
          </form>

          <p className={styles.foot}>Acceso restringido al personal autorizado.</p>
        </div>
      </div>
    </main>
  );
}
